import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { IItem } from '../../models/IItem';

@Component({
  selector: 'item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.scss']
})
export class ItemListComponent {
  @Input() items: IItem[];
  @Output() delete = new EventEmitter();
  @Output() edit = new EventEmitter();

}
